import {
  IAcademicsCourses,
  ESubjectType,
} from '../../apis/academics/academicsClassesAndCourses.interfaces';

export const mockAcademicsCourses: IAcademicsCourses[] = [
  // English courses by grade level
  {
    id: 1,
    name: 'English - Class 1',
    description: 'English language basics for Class 1',
    subjectCode: 'ENG-01',
    classIds: [1], // Class 1
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 2,
    name: 'English - Class 2',
    description: 'English language for Class 2',
    subjectCode: 'ENG-02',
    classIds: [2], // Class 2
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 3,
    name: 'English - Class 3',
    description: 'English language for Class 3',
    subjectCode: 'ENG-03',
    classIds: [3], // Class 3
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 4,
    name: 'English - Class 4',
    description: 'English language for Class 4',
    subjectCode: 'ENG-04',
    classIds: [4], // Class 4
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 5,
    name: 'English - Class 5',
    description: 'English language for Class 5',
    subjectCode: 'ENG-05',
    classIds: [5], // Class 5
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 6,
    name: 'English - Class 6',
    description: 'English language for Class 6',
    subjectCode: 'ENG-06',
    classIds: [6, 7], // Class 6A, 6B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 7,
    name: 'English - Class 7',
    description: 'English language for Class 7',
    subjectCode: 'ENG-07',
    classIds: [8, 9], // Class 7A, 7B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 8,
    name: 'English - Class 8',
    description: 'English language for Class 8',
    subjectCode: 'ENG-08',
    classIds: [10, 11], // Class 8A, 8B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 9,
    name: 'English - Class 9',
    description: 'English language for Class 9',
    subjectCode: 'ENG-09',
    classIds: [12, 13], // Class 9A, 9B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 10,
    name: 'English - Class 10',
    description: 'English language for Class 10',
    subjectCode: 'ENG-10',
    classIds: [14, 15], // Class 10A, 10B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 11,
    name: 'English - Class 11 (Science)',
    description: 'English language for Class 11 Science',
    subjectCode: 'ENG-11-SCI',
    classIds: [16, 17], // Class 11 Science A, B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 12,
    name: 'English - Class 11 (Commerce)',
    description: 'English language for Class 11 Commerce',
    subjectCode: 'ENG-11-COM',
    classIds: [18], // Class 11 Commerce
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 13,
    name: 'English - Class 11 (Arts)',
    description: 'English language for Class 11 Arts',
    subjectCode: 'ENG-11-ARTS',
    classIds: [19], // Class 11 Arts
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 14,
    name: 'English - Class 12 (Science)',
    description: 'English language for Class 12 Science',
    subjectCode: 'ENG-12-SCI',
    classIds: [20, 21], // Class 12 Science A, B
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 15,
    name: 'English - Class 12 (Commerce)',
    description: 'English language for Class 12 Commerce',
    subjectCode: 'ENG-12-COM',
    classIds: [22], // Class 12 Commerce
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 16,
    name: 'English - Class 12 (Arts)',
    description: 'English language for Class 12 Arts',
    subjectCode: 'ENG-12-ARTS',
    classIds: [23], // Class 12 Arts
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 17,
    name: 'English - Class 11 (Vocational)',
    description: 'English language for Class 11 Vocational',
    subjectCode: 'ENG-11-VOC',
    classIds: [25], // Class 11 Vocational
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 18,
    name: 'English - Class 12 (Vocational)',
    description: 'English language for Class 12 Vocational',
    subjectCode: 'ENG-12-VOC',
    classIds: [24], // Class 12 Vocational
    teacherId: 2,
    subjectType: ESubjectType.LANGUAGE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },

  // Mathematics courses by grade level
  {
    id: 19,
    name: 'Mathematics - Class 1',
    description: 'Basic mathematics for Class 1',
    subjectCode: 'MATH-01',
    classIds: [1], // Class 1
    teacherId: 1,
    subjectType: ESubjectType.MATHEMATICS,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 20,
    name: 'Mathematics - Class 2',
    description: 'Basic mathematics for Class 2',
    subjectCode: 'MATH-02',
    classIds: [2], // Class 2
    teacherId: 1,
    subjectType: ESubjectType.MATHEMATICS,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },

  // Science courses
  {
    id: 35,
    name: 'EVS - Class 1',
    description: 'Environmental Studies for Class 1',
    subjectCode: 'EVS-01',
    classIds: [1], // Class 1
    teacherId: 8,
    subjectType: ESubjectType.SCIENCE,
    isElective: false,
    weightage: 75,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 36,
    name: 'EVS - Class 2',
    description: 'Environmental Studies for Class 2',
    subjectCode: 'EVS-02',
    classIds: [2], // Class 2
    teacherId: 8,
    subjectType: ESubjectType.SCIENCE,
    isElective: false,
    weightage: 75,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },

  // Physics, Chemistry and Biology for higher classes (9-12 Science)
  {
    id: 50,
    name: 'Physics - Class 9',
    description: 'Physics for Class 9',
    subjectCode: 'PHY-09',
    classIds: [12, 13], // Class 9A, 9B
    teacherId: 10,
    subjectType: ESubjectType.SCIENCE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 51,
    name: 'Physics - Class 10',
    description: 'Physics for Class 10',
    subjectCode: 'PHY-10',
    classIds: [14, 15], // Class 10A, 10B
    teacherId: 10,
    subjectType: ESubjectType.SCIENCE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 52,
    name: 'Physics - Class 11 (Science)',
    description: 'Advanced Physics for Class 11 Science',
    subjectCode: 'PHY-11',
    classIds: [16, 17], // Class 11 Science A, B
    teacherId: 10,
    subjectType: ESubjectType.SCIENCE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 53,
    name: 'Physics - Class 12 (Science)',
    description: 'Advanced Physics for Class 12 Science',
    subjectCode: 'PHY-12',
    classIds: [20, 21], // Class 12 Science A, B
    teacherId: 10,
    subjectType: ESubjectType.SCIENCE,
    isElective: false,
    weightage: 100,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },

  // Commerce specific subjects
  {
    id: 70,
    name: 'Accountancy - Class 11 (Commerce)',
    description: 'Accountancy for Class 11 Commerce',
    subjectCode: 'ACC-11',
    classIds: [18], // Class 11 Commerce
    teacherId: 14,
    subjectType: ESubjectType.VOCATIONAL,
    isElective: false,
    weightage: 100,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 71,
    name: 'Business Studies - Class 11 (Commerce)',
    description: 'Business Studies for Class 11 Commerce',
    subjectCode: 'BUS-11',
    classIds: [18], // Class 11 Commerce
    teacherId: 13,
    subjectType: ESubjectType.VOCATIONAL,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 72,
    name: 'Accountancy - Class 12 (Commerce)',
    description: 'Advanced Accountancy for Class 12 Commerce',
    subjectCode: 'ACC-12',
    classIds: [22], // Class 12 Commerce
    teacherId: 14,
    subjectType: ESubjectType.VOCATIONAL,
    isElective: false,
    weightage: 100,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 73,
    name: 'Business Studies - Class 12 (Commerce)',
    description: 'Advanced Business Studies for Class 12 Commerce',
    subjectCode: 'BUS-12',
    classIds: [22], // Class 12 Commerce
    teacherId: 13,
    subjectType: ESubjectType.VOCATIONAL,
    isElective: false,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },

  // Elective subjects
  {
    id: 90,
    name: 'Computer Science - Class 8',
    description: 'Introduction to Computer Science for Class 8',
    subjectCode: 'CS-08',
    classIds: [10, 11], // Class 8A, 8B
    teacherId: 5,
    subjectType: ESubjectType.COMPUTER,
    isElective: true,
    weightage: 75,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 91,
    name: 'Computer Science - Class 9',
    description: 'Computer Science for Class 9',
    subjectCode: 'CS-09',
    classIds: [12, 13], // Class 9A, 9B
    teacherId: 5,
    subjectType: ESubjectType.COMPUTER,
    isElective: true,
    weightage: 75,
    practicalsIncluded: true,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  {
    id: 92,
    name: 'French - Class 8',
    description: 'French language for Class 8',
    subjectCode: 'FRE-08',
    classIds: [10, 11], // Class 8A, 8B
    teacherId: 18,
    subjectType: ESubjectType.LANGUAGE,
    isElective: true,
    weightage: 100,
    practicalsIncluded: false,
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
  },
  // Add more courses as needed...
];
